/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


if ($('.slick-main')) {
  $('.slick-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slick-sub',
    slide: ".slick-imgWrap"
  });
  $('.slick-sub').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slick-main',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: false,
    arrows: false
  });
}

$(".js-clickZoom").on("click", function () {
  $("#js-addedClass").addClass("zoom");
  $("#js-hiddenButton").addClass("hidden");
  $("body").css({"height": "100%", "overflow": "hidden"});
  $("#js-closeModal").css("display", "block");
  $(".js-clickZoom").css("width", "100vw");
  $(this).addClass("zoom");
  $("#js-changePosition").addClass("zoom");
  if (window.innerWidth > window.innerHeight) {
    $(".js-clickZoom img").css({"height": "100vh", "width": "auto"});
  } else {
    $("#js-addedClass").addClass("mobile");
    $("#js-closeModal").addClass("mobile");
    $(".js-clickZoom img").css({"height": "auto", "width": "100vw"});
  }
});
$("#js-closeModal").on("click", function () {
  $("#js-hiddenButton").removeClass("hidden");
  $("#js-changePosition").removeClass("zoom");
  $(".js-clickZoom").removeClass("zoom");
  $("#js-closeModal").removeClass("mobile");
  $("#js-addedClass").removeClass("zoom");
  $("body").css({"height": "auto", "overflow": "auto"});
  $("#js-closeModal").css("display", "none");
  $("#js-addedClass").removeClass("mobile");
  $(".js-clickZoom img").css({"height": "100%", "width": "100%"});
  const width = $("#js-addedClass").width();
  $(".js-clickZoom").css("width", width);
});
